import { FileValidationDataDTO, FileErrorTypes } from '../file';

export interface SubtitlesFileValidationDataDTO extends Omit<FileValidationDataDTO, 'error'> {
    error?: FileErrorTypes;
}

export class SubtitlesFileValidationDataModel {
    hash: string | null;
    error: FileErrorTypes | null;

    constructor(data: SubtitlesFileValidationDataDTO) {
        this.hash = data?.hash || null;
        this.error = data?.error || null;
    }
}
